import React from "react";
import { withI18n } from "react-i18next";
import styled from "styled-components";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { RouteComponentProps } from "react-router-dom";

// @ts-ignore
import { moment, CWBTableCell } from "cwb-react";
import { Button } from "../../Common";
import {
  IAuditionsDto,
  ICheckInDto,
  IDeleteAuditionDto,
} from "../../../shared/dto/IKioskDto";
import { iRootState } from "../../../store";
import { client } from "../../../shared/apiClient";
import { IAuditionInfoSheetDto } from "../../../interfaces/IAuditionInfoSheetDto";
import PlayerModal from "../../Modals/PlayerModal";
import { IMedia } from "../../../interfaces/IMedia";

import Dash from "../../../images/dash.svg";
import AlertPink from "../../../images/alert-pink.svg";
import CheckGreen from "../../../images/check-green.svg";
import DragImg from "../../../images/drag_indicator.svg";
import { isFutureAudition, isPastAuditionCheckInOut } from "../../../helpers";
import { IKioskSessionAuditionsDto } from "../../../interfaces/IKioskSessionAuditionsDto";
import { IKioskSessionInfo } from "../../../interfaces/IKioskSessionInfo";
import DisplayPopOver from "./DisplayPopOver";

interface IState {
  popoverOpen: boolean;
  checkInfo: ICheckInDto;
  showVideoPlayer: boolean;
  isDeleted: boolean;
}

interface IProps extends StateProps, DispatchProps, RouteComponentProps<any> {
  t?: any;
  row: IAuditionsDto;
  rowProps: any;
  provided: any;
  snapshot: any;
}

class KioskSessionAuditionsRow extends React.Component<IProps, IState> {
  public state: IState = {
    popoverOpen: false,
    checkInfo: this.props.checkInInfo,
    showVideoPlayer: false,
    isDeleted: false,
  };

  componentDidMount(){

    this.setState({isDeleted : this.props.row.isDelete});
  }

  toggle = () => {
    this.setState({ popoverOpen: !this.state.popoverOpen });
  };

  updateTime = async (time: string, field: string) => {
    let newTime = moment.moment(time, "HH:mm").format("hh:mm a");
    let checkInfo = this.state.checkInfo;
    if (field === "checkin")
      checkInfo = { ...checkInfo, checkedIn: newTime, checkInStatus: "Edit" };
    else
      checkInfo = { ...checkInfo, checkedOut: newTime, checkInStatus: "Edit" };
    await this.setState({ checkInfo });
  };

  saveCheckInfo = () => {
    this.props.addEditCheckIn(this.state.checkInfo);
    this.setState({ popoverOpen: false });
  };

  deleteCheckIn = () => {
    this.props.deleteCheckIn(this.state.checkInfo.checkInId);
    this.setState({ popoverOpen: false });
  };

  // TODO: move to own compo file
  displayCheckInDate = () => {
    const {
      checkInInfo,
      pastAudition,
      futureAudition,
      addEditCheckIn,
      t,
      sessionAudition,
    } = this.props;
    const isCheckIn = checkInInfo && checkInInfo.checkedIn;

    if (sessionAudition.isDelete && isCheckIn) {
      return checkInInfo.checkedIn;
    }
    if (
      (pastAudition && !isCheckIn) ||
      (sessionAudition.isDelete && !isCheckIn)
    ) {
      return null;
    } else if (futureAudition) {
      return (
        <StyledButton disabled variant="secondary">
          {t("Check-in")}
        </StyledButton>
      );
    } else {
      return (
        <>
          {checkInInfo && checkInInfo.checkedIn ? (
            moment.moment(checkInInfo.checkedIn, "h:mm A").format("h:mm A")
          ) : (
            <StyledButton
              variant="secondary"
              onClick={() => {
                let checkInfo = {
                  ...this.state.checkInfo,
                  checkedIn: moment.moment().format("hh:mm a"),
                  checkInStatus: "In",
                };
                this.setState({ checkInfo });
                addEditCheckIn(checkInfo);
              }}
            >
              {t("Check-in")}
            </StyledButton>
          )}
        </>
      );
    }
  };

  // TODO: move to own component file
  displayCheckoutDate = () => {
    const {
      row,
      checkInInfo,
      pastAudition,
      futureAudition,
      addEditCheckIn,
      t,
      sessionAudition,
    } = this.props;
    const isCheckIn = checkInInfo && checkInInfo.checkedIn;

    if (sessionAudition.isDelete && isCheckIn) {
      return checkInInfo.checkedIn;
    }
    if (
      (pastAudition && !isCheckIn) ||
      (sessionAudition.isDelete && !isCheckIn)
    ) {
      return null;
    } else if (futureAudition) {
      return (
        <StyledButton disabled variant="secondary">
          {t("Checkout")}
        </StyledButton>
      );
    } else {
      return (
        <>
          {checkInInfo.checkedOut ? (
            <>
              {" "}
              {moment.moment(checkInInfo.checkedOut, "h:mm A").format("h:mm A")}
              <i
                id={`Popover${row.scheduleId}`}
                className="icon-cwb-edit-new grey"
                style={{
                  marginLeft: "8px",
                  display: `${pastAudition ? "none" : ""}`,
                  cursor: "pointer",
                }}
                onClick={this.toggle}
              ></i>
              <DisplayPopOver
                scheduleId={row.scheduleId}
                popoverOpen={this.state.popoverOpen}
                deleteCheckIn={this.deleteCheckIn}
                saveCheckInfo={this.saveCheckInfo}
                toggle={this.toggle}
                updateTime={this.updateTime}
                checkInfo={this.state.checkInfo}
              />
            </>
          ) : (
            <StyledButton
              disabled={!isCheckIn || pastAudition}
              variant="secondary"
              onClick={() => {
                if (!isCheckIn) return;
                let checkInfo = {
                  ...this.state.checkInfo,
                  checkInId: this.state.checkInfo.checkInId
                    ? this.state.checkInfo.checkInId
                    : this.props.checkInInfo.checkInId,
                  checkedOut: moment.moment().format("hh:mm a"),
                  checkInStatus: "Out",
                };
                this.setState({ checkInfo });
                addEditCheckIn(checkInfo);
              }}
            >
              {t("Checkout")}
            </StyledButton>
          )}
        </>
      );
    }
  };

  onClickViewInfoSheet = (e: any, row: IAuditionsDto, infoSheetId: number) => {
    e.preventDefault();
    this.props.history.push({
      pathname: `/auditionInfoSheet/${row.scheduleId}/${infoSheetId}/${row.auditionScheduleId}`,
    });
  };

  onToggleVideoPlayer = () => {
    this.setState((prevState) => ({
      showVideoPlayer: !prevState.showVideoPlayer,
    }));
  };

  onClickVideoPlayer = async (e: any) => {
    if (e) e.preventDefault();

    // TODO: get media details via PM api
    await this.getVideo();

    this.setState((prevState) => ({
      showVideoPlayer: true,
    }));
  };

  getVideo = async () => {
    const { row } = this.props;
    if (!row || !row.videoDirection) return; // TODO: throw error
    await this.props.getMedia(row.videoDirection.videoId);
  };

  getInfoSheetIcon = () => {
    const { auditionInfoSheet } = this.props;

    if (!auditionInfoSheet) return "";

    if (
      auditionInfoSheet.hasConflict === 0 ||
      auditionInfoSheet.hasConflict === 1
    )
      return CheckGreen;

    if (auditionInfoSheet.hasConflict === 2) return AlertPink;

    return Dash;
  };

  draggingItemStyle = (isDragging: boolean, draggableStyle: any) => ({
    ...draggableStyle,
    background: isDragging ? "#FFF" : "#FFF",
    border: isDragging ? "1px solid #E9EDED" : "",
    boxShadow: isDragging
      ? "0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)"
      : "",
  });

  render() {
    const {
      row,
      auditionInfoSheet,
      t,
      pastAudition,
      media,
      sessionAudition,
      sessionAuditions,
      provided,
      snapshot,
    } = this.props;
    const { showVideoPlayer, isDeleted } = this.state;

    const bdType = sessionAuditions.bdType;

    const infoSheetsEnabled = this.props.sessionInfo.infoSheetsEnabled;

    // hasConflict : 1 = available, 2  = partially avaialble, 3 - not available.

    const url =
      media &&
      media.sources &&
      media.sources.length > 0 &&
      media.sources[0].url;

    return (
      <>
        <PlayerModal
          open={showVideoPlayer}
          toggleModal={this.onToggleVideoPlayer}
          url={url}
        />
        <tr
          key={row.auditionScheduleId}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={this.draggingItemStyle(
            snapshot.isDragging,
            provided.draggableProps.style
          )}
          className={isDeleted ? "deleted" : ""}
        >
          <td ref="firstColRef" className="first-col">
            <img src={DragImg} alt="" />
          </td>
          <OrderCell snapshot={snapshot}>
            {row.order ? row.order : ""}
          </OrderCell>
          <TimeCell snapshot={snapshot}>{row.auditionTime}</TimeCell>
          <ActorCell snapshot={snapshot}>{row.actor}</ActorCell>
          <RoleCell snapshot={snapshot}>
            {bdType === 2 && `${row.spot} - `}
            {row.videoDirection ? (
              <StyledLink onClick={(e) => this.onClickVideoPlayer(e)} href="">
                {row.role}
              </StyledLink>
            ) : (
              row.role
            )}
          </RoleCell>
          <InfoSheetCell snapshot={snapshot}>
            {!sessionAudition.isDelete && (
              <>
                {!infoSheetsEnabled ? (
                  <DisabledInfoSheet>-</DisabledInfoSheet>
                ) : auditionInfoSheet ? (
                  <>
                    <StyledLink
                      href="#"
                      onClick={(e) =>
                        this.onClickViewInfoSheet(
                          e,
                          row,
                          auditionInfoSheet.infoSheetId
                        )
                      }
                    >
                      {t("View Sheet")}
                    </StyledLink>
                    <StyledImgIcon src={this.getInfoSheetIcon()} />
                    <a
                      href={`${client.api.paths.domain}/castingworkbook/directors/printinfosheet.asp?asid=${row.auditionScheduleId}&cid=${auditionInfoSheet.clientId}&isid=${auditionInfoSheet.infoSheetId}`}
                    >
                      <i className="icon-cwb-print-new"></i>
                    </a>
                  </>
                ) : (
                  // No Audition Info Sheet
                  <>
                    <StyledLink
                      href=""
                      onClick={(e) => this.onClickViewInfoSheet(e, row, 0)}
                    >
                      {t("No Sheet")}
                    </StyledLink>
                    <StyledIPrint className="icon-cwb-print-new disabled"></StyledIPrint>
                  </>
                )}
              </>
            )}
          </InfoSheetCell>
          <td>{this.displayCheckInDate()}</td>
          <CheckoutCell snapshot={snapshot}>
            {this.displayCheckoutDate()}
          </CheckoutCell>
          <td>
            {pastAudition ? (
              <></>
            ) : !sessionAudition.isDelete ? (
              <i
                className="icon-cwb-clear-circle grey"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  this.setState({isDeleted: true});
                  this.props.deleteAudition({
                    auditionScheduleId: row.auditionScheduleId,
                    scheduleId: row.scheduleId,
                  });
                }}
              ></i>
            ) : (
              <i
                className="icon-cwb-check-circle blue"
                onClick={() => {
                  this.setState({isDeleted: false});
                  this.props.restoreAudition({
                    auditionScheduleId: row.auditionScheduleId,
                    scheduleId: row.scheduleId,
                  });
                }}
              ></i>
            )}
          </td>
        </tr>
      </>
    );
  }
}

interface StateProps {
  sessionAuditions: IKioskSessionAuditionsDto;
  sessionAudition: IAuditionsDto;
  checkInInfo: ICheckInDto;
  auditionInfoSheet: IAuditionInfoSheetDto;
  pastAudition: boolean;
  futureAudition: boolean;
  media: IMedia;
  sessionInfo: IKioskSessionInfo;
}

function mapStateToProps(state: iRootState, ownProps: any): StateProps {
  let sessionAuditions = state.kiosk.sessionAuditions;
  let checkInInfo =
    sessionAuditions.auditionCheckIns &&
    sessionAuditions.auditionCheckIns.find(
      (checkIn: ICheckInDto) =>
        checkIn.auditionScheduleId === ownProps.row.auditionScheduleId
    );
  let auditionInfoSheet =
    sessionAuditions.auditionInfoSheets &&
    sessionAuditions.auditionInfoSheets.find(
      (infoSheet: IAuditionInfoSheetDto) =>
        infoSheet.auditionScheduleId === ownProps.row.auditionScheduleId
    );

  let sessionAudition =
    sessionAuditions.auditionsDetails &&
    sessionAuditions.auditionsDetails.length > 0 &&
    sessionAuditions.auditionsDetails.find(
      (o: IAuditionsDto) =>
        o.auditionScheduleId === ownProps.row.auditionScheduleId
    );

  let pastAudition = false;
  let futureAudition = false;
  if (state.kiosk.sessionAuditions) {
    if (
      sessionAuditions.auditionsDetails &&
      sessionAuditions.auditionsDetails.length > 0
    ) {
      pastAudition = isPastAuditionCheckInOut(
        sessionAuditions.auditionsDetails[
          sessionAuditions.auditionsDetails.length - 1
        ].auditionTime,
        sessionAuditions.auditionDate
      );
      futureAudition = isFutureAudition(
        sessionAuditions.auditionsDetails[0].auditionTime,
        sessionAuditions.auditionDate
      );
    }
  }
  return {
    sessionAuditions,
    checkInInfo:
      checkInInfo ||
      ({ auditionScheduleId: ownProps.row.auditionScheduleId } as ICheckInDto),
    auditionInfoSheet,
    pastAudition,
    futureAudition,
    media: state.kiosk.media,
    sessionAudition,
    sessionInfo: state.kiosk.sessionInfo,
  };
}

interface DispatchProps {
  addEditCheckIn: (dto: ICheckInDto) => void;
  deleteCheckIn: (checkInId: number) => void;
  deleteAudition: ({
    auditionScheduleId,
    scheduleId,
  }: IDeleteAuditionDto) => void;
  restoreAudition: ({
    auditionScheduleId,
    scheduleId,
  }: IDeleteAuditionDto) => void;
  getMedia: (id: number) => void;
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    addEditCheckIn: dispatch.kiosk.addEditCheckIn,
    deleteCheckIn: dispatch.kiosk.deleteCheckIn,
    deleteAudition: dispatch.kiosk.deleteAudition,
    restoreAudition: dispatch.kiosk.restoreAudition,
    getMedia: dispatch.kiosk.getMedia,
  };
}

export default withI18n()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(KioskSessionAuditionsRow))
);

const Cell = styled(CWBTableCell)<{ snapshot: any }>`
  width: ${(props: any) => (props.snapshot.isDragging ? `200px` : ``)};
`;

const OrderCell = styled(Cell)`
  padding-left: 24px !important;
`;

const TimeCell = styled(Cell)`
  padding-left: 24px !important;
`;

const ActorCell = styled(Cell)`
  font-weight: ${(p) => p.theme["font-weight-600"]};
`;

const RoleCell = styled(Cell)``;

const InfoSheetCell = styled(Cell)``;

const CheckoutCell = styled(Cell)`
  .icon-cwb-edit-new:hover {
    color: ${(p) => p.theme.lightBlue};
  }
`;

const StyledLink = styled.a`
  margin-right: 16px;
  &&&,
  &:hover {
    color: ${(p) => p.theme.grey};
    font-weight: normal;
    text-decoration: underline;
  }
`;

const StyledButton = styled(Button)`
  height: 32px;
  font-size: ${(p) => p.theme["xs-font-size"]};
`;

const StyledImgIcon = styled.img`
  margin-right: 14px;
  padding-bottom: 4px;
  width: 16px;
`;

const StyledIPrint = styled.i`
  margin-left: 42px;
`;

const DisabledInfoSheet = styled.div`
  margin-left: -24px;
  text-align: center;
`;
